import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const parseLocalStorageItem = (key: string): any => {
  const item = localStorage.getItem(key)
  if (item === null || item === '') {
    return null
  }
  try {
    return JSON.parse(item)
  } catch (error) {
    console.error(`Error parsing localStorage key "${key}" with value "${item}":`, error)
    return null
  }
}
